import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-bath-white',
  templateUrl: './icon-bath-white.component.html',
  styles: []
})
export class IconBathWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
